// extracted by mini-css-extract-plugin
export default {"card":"card_card__XoCn7","highlight":"card_highlight__pv-bg","remarcar":"card_remarcar__7qFHo"};